import { render, staticRenderFns } from "./myTicket.vue?vue&type=template&id=52959ba4&scoped=true&"
import script from "./myTicket.vue?vue&type=script&lang=js&"
export * from "./myTicket.vue?vue&type=script&lang=js&"
import style0 from "./myTicket.vue?vue&type=style&index=0&id=52959ba4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52959ba4",
  null
  
)

export default component.exports